import React from 'react';
import DaterangePicker from 'react-bootstrap-daterangepicker';
import _get from 'lodash/get';
import './manualDataFilter.css';
import {useTranslation} from 'react-i18next';
import timeUtils from '../../utils/timeUtils';

export const TextFilter = ({column: {filterValue, setFilter}}) => {
  return (
    <input
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined);
      }}
      className="form-control input-sm"
    />
  );
};

export const DropdownFilter = ({
  column: {filterValue, setFilter, options, defaultWord = ''},
}) => {
  if (options) {
    // manual
    return (
      <select
        onChange={e => setFilter(e.target.value || '')}
        value={filterValue || ''}
        className="form-control input-sm"
      >
        <option value="">{defaultWord}</option>
        {options.map((opt, i) => (
          <option key={i} value={opt.value}>
            {opt.text || opt.label}
          </option>
        ))}
      </select>
    );
  }
  return '';
};

export const DateRangeFilter = ({
  column: {filterValue, setFilter, dateRangeQuery},
}) => {
  const {t} = useTranslation();
  return (
    <DaterangePicker
      onApply={(event, picker) => {
        const {startDate, endDate} = picker;
        const display = `${startDate.format(
          timeUtils.shortTimeFormat()
        )} - ${endDate.format(timeUtils.shortTimeFormat())}`;
        setFilter({
          [_get(dateRangeQuery, '[0]', 'startDateFrom')]: startDate.valueOf(),
          [_get(dateRangeQuery, '[1]', 'startDateTo')]: endDate.valueOf(),
          display,
        });
      }}
      drops="down"
      opens="center"
      locale={{
        customRangeLabel: t('c.r.daterange.custom.range', 'Custom Range'),
        applyLabel: t('c.r.daterange.apply', 'Apply'),
        cancelLabel: t('c.r.daterange.cancel', 'Cancel'),
        format: timeUtils.shortTimeFormat(),
        monthNames: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        daysOfWeek: [
          t('c.r.daterange.sunday', 'Su'),
          t('c.r.daterange.monday', 'Mo'),
          t('c.r.daterange.tuesday', 'Tu'),
          t('c.r.daterange.wednesday', 'We'),
          t('c.r.daterange.thursday', 'Th'),
          t('c.r.daterange.friday', 'Fr'),
          t('c.r.daterange.saturday', 'Sa'),
        ],
      }}
    >
      <div className="input-group" style={{flexWrap: 'nowrap'}}>
        <div className="input-group-prepend">
          <span className="input-group-text">
            <i className="fa fa-calendar" />
          </span>
        </div>
        <input
          type="text"
          className="form-control input-sm"
          value={filterValue ? filterValue.display : ''}
          readOnly={true}
          style={{backgroundColor: '#fff'}}
        />
      </div>
    </DaterangePicker>
  );
};
